import React from 'react'

import Checkbox from '../Fields/Checkbox'
import TextArea from '../Fields/TextArea'
import classes from './layout.css'

const ModuleThirtyFour = (props) => {
	return (
		<div>
			<p>You have the right to be informed about your diagnosis and planned surgery so that you may make a decision whether or not to undergo a procedure after knowing the risks, benefits and alternatives. This disclosure is not meant to frighten or alarm you. It is simply an effort to improve your understanding of the procedure and allow you to provide your informed consent to undergo the procedure.</p>
			<h3>POSSIBLE COMPLICATIONS (may be variable in occurrence):</h3>
			<ul>
				<li> 
					<Checkbox
						controlFunc={props.addToForm}
						name={"allSurgeries"}
						value={props.consentForm.allSurgeries}
					/>ALL SURGERIES

					<ol type="a">
						<li>Soreness, swelling, bruising and restricted mouth opening during healing. This is sometimes related to swelling and muscle tenderness. This may be related to stress at the jaw joints (TMJ), especially when TMJ problems already exist.</li>
						<li>Bleeding, usually controllable, but may be prolonged and require additional care.</li>
						<li>Drug reactions or allergies.</li>
						<li>Infection: possibly requiring additional care.</li>
					</ol>
				</li>
				<li>
					<Checkbox
						controlFunc={props.addToForm}
						name={"allToothExtraction"}
						value={props.consentForm.allToothExtraction}
					/>ALL TOOTH EXTRACTIONS

					<ol type="a">
						<li>Dry Socket; discomfort occurring approximately five days after tooth extraction; requires additional care.</li>
						<li>Damage to adjacent teeth and fillings.</li>
						<li>Sharp edges or bone splinters; may require additional surgery to smooth the area.</li>
						<li>Portions of tooth remaining- rarely fine root tips break off and may be deliberately left in place to avoid damage to nearby vital structures (i.e. nerves and sinuses).</li>
					</ol>
				</li>
				<li>
					<Checkbox
						controlFunc={props.addToForm}
						name={"lowerTeeth"}
						value={props.consentForm.lowerTeeth}
					/>LOWER TEETH

					<ol type="a">
						<li>Numbness and loss of taste sensation: Due to the proximity of roots to the nerve (especially wisdom teeth), it is possible to injure the nerve during removal of the tooth. The lip, chin, gums and/or tongue could thus feel numb (resembling local anesthetic injection), and this could remain for days, weeks, or very rarely, permanently.</li>
					</ol>
				</li>
				<li> 
					<Checkbox
						controlFunc={props.addToForm}
						name={"upperTeeth"}
						value={props.consentForm.upperTeeth}
					/>UPPER TEETH

					<ol type="a">
						<li>Sinus Involvement: Due to the closeness of the roots of the upper back teeth to the sinus or from a root tip being displaced into the sinus, a possible sinus infection and/or sinus opening may result. This may require medication and/or later surgery to correct.</li>
					</ol>
				</li>
			</ul>
			<h3>ANESTHESIA</h3>
			<div className={classes.Anesthesia}>
				<Checkbox 
					controlFunc={props.addToForm} 
					name={"localAnesthesia"}
					value={props.consentForm.localAnesthesia}
				/>Local Anesthesia <br />
				<Checkbox 
					controlFunc={props.addToForm} 
					name={"ivSedation"}
					value={props.consentForm.ivSedation}
				/>Intravenous sedation or General Anesthesia or Deep Sedation
			</div>
			<p>Certain risks exist, although uncommon, could include nausea, pain, swelling, inflammation and/or bruising at the injection site. Although rare, other risks could include: nerve damage, allergic reactions, heart attack, stroke, brain damage and/or death.</p>
			<div>
				<Checkbox 
					controlFunc={props.addToForm} 
					name={"consent"}
					value={props.consentForm.consent}
				/><strong>I understand that I am to have NO FOOD OR DRINK FOR EIGHT (8) HOURS BEFORE my appointment. To do otherwise may be life threatening.</strong>
			</div>
			<div>
				<Checkbox
					controlFunc={props.addToForm}
					name={"altTreatmentOptions"}
					id={"initial"}
					value={props.consentForm.altTreatmentOptions.initial}
				/>ALTERNATIVE TREATMENT OPTIONS:
				<TextArea
					controlFunc={props.addToForm}
					inputType={"text"}
					name={"altTreatmentOptions"}
					id={"description"}
					value={props.consentForm.altTreatmentOptions.description}
				/>
			</div>
		</div>
	)
}

export default ModuleThirtyFour


// WEBPACK FOOTER //
// ./src/components/Modules/34.js